export default "__VITE_ASSET__d884f312__"